<script lang="ts" setup>
defineProps<{
  title?: string
  subTitle?: string
  center?: boolean
  padding?: boolean
  fullHeight?: boolean
}>()
</script>

<template>
  <div
    class="m-container"
    :class="{
      fullHeight
    }"
  >
    <div
      v-if="title"
      class="m-container__title"
      :style="{
        textAlign: center ? 'center' : 'left'
      }"
    >
      <span class="title">{{ title }}</span>
      <span class="subtitle">
        <slot name="subtitle" />
      </span>
    </div>
    <div
      class="m-container__body"
      :style="{
        padding: padding ? '12px 16px' : '0'
      }"
    >
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-container {
  background: #fff;
  border-radius: 8px;
  &__title {
    display: flex;
    padding: 10px 16px;
    width: 100%;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    justify-content: space-between;
    .title {
      font-size: 16px;
      color: var(--color-gray-900);
      //font-weight: bold;
    }
  }
}
.m-container.fullHeight {
  height: 100%;
  display: flex;
  flex-direction: column;
  .m-container {
    &__body {
      flex: 1;
      width: 0;
    }
  }
}
</style>
